import { Staff } from '../Entities/Personas/Staff';
import { SearchDto } from './common/searchDto';

export class SearchStaffDto extends SearchDto<Staff, never> {
  firstName?: string;
  lastName?: string;
  email?: string;
  isArchived?: boolean;
}
